import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slot"]
  static classes = ["selected"]

  static values = {
    slotSize: Number,
    selectionFirst: { type: Number, default: null },
    selectionBegin: { type: Number, default: null },
    selectionEnd: { type: Number, default: null },
  }

  selectionInProgress() {
    return this.selectionStartValue !== null && this.selectionEndValue !== null
  }

  selectStart(event) {
    const start = Date.parse(event.params.datetime)
    
    // Track which grid this selection is in
    const slot = event.currentTarget
    this.selectionGrid = slot.dataset.scheduleGrid || null
    
    this.selectionFirstValue = Date.parse(event.params.datetime)
    this.selectionBeginValue = Date.parse(event.params.datetime)
    this.selectionEndValue = Date.parse(event.params.datetime)
  }

  selectHover(event) {
    if(!this.selectionInProgress()) { return; }
    
    // Only extend selection within the same grid
    const slot = event.currentTarget
    const slotGrid = slot.dataset.scheduleGrid
    
    if(this.selectionGrid && slotGrid !== this.selectionGrid) {
      return
    }
    
    const datetime = Date.parse(event.params.datetime)

    if(datetime <= this.selectionFirstValue) {
      this.selectionBeginValue = datetime
    }

    if(datetime >= this.selectionFirstValue) {
      this.selectionEndValue = datetime
    }
  }

  selectEnd(event) {
    if(!this.selectionInProgress()) { return; }

    // Dispatch calendar:selection event before clearing
    const selectionEvent = new CustomEvent("calendar:selection", {
      detail: {
        startTime: this.selectionBeginValue,
        endTime: this.selectionEndValue + (this.slotSizeValue * 60 * 1000),
        gridType: this.selectionGrid,
      },
      bubbles: true,
      cancelable: true
    })
    this.element.dispatchEvent(selectionEvent)

    this.selectionFirstValue = null
    this.selectionBeginValue = null
    this.selectionEndValue = null
    this.selectionGrid = null
  }

  selectionChanged() {
    if(!this.selectionInProgress()) { return; }
    
    this.slotTargets.forEach(slot => {
      // Only highlight slots in the same grid as the selection started
      const slotGrid = slot.dataset.scheduleGrid
      if(this.selectionGrid && slotGrid !== this.selectionGrid) {
        slot.classList.remove(this.selectedClass)
        return
      }
      
      const slotDatetime = Date.parse(slot.dataset.calendarSelectDatetimeParam)
      if(
        this.selectionBeginValue <= slotDatetime &&
        slotDatetime < (this.selectionEndValue + this.slotSizeValue * 60 * 1000)
      ) {
        slot.classList.add(this.selectedClass)
      } else {
        slot.classList.remove(this.selectedClass)
      }
    })
  }

  selectionBeginValueChanged() {
    this.selectionChanged()
  }

  selectionEndValueChanged() {
    this.selectionChanged()
  }
}